import { render, staticRenderFns } from "./GroupedModifiers.vue?vue&type=template&id=015cd996&lang=pug"
import script from "./GroupedModifiers.vue?vue&type=script&lang=js"
export * from "./GroupedModifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports